import {
  getCategoryPageTypeConfig,
  getPageTypeForSlug,
} from './categoryPageTypes';

/**
 * Builds the Algolia `numericFilters` array for the category page.
 *
 * Shared by both `<Configure>` sites (the root index in `index.js` and the sort
 * replica `<Index>` in `CategoryAlgoliaLayout`) so the replica cannot drift.
 *
 * The leading availability/visibility bounds come from the descriptor's
 * `baseNumericFilters` — the defaults everywhere except a sale page that lists
 * discontinued products on purpose (see CLEARANCE in `categoryPageTypes.js`).
 */
const buildCategoryAlgoliaNumericFilters = ({
  slug,
  pageType,
  minWidth,
  maxWidth,
  nowMs,
}) => {
  const { baseNumericFilters, extraNumericFilters } = getCategoryPageTypeConfig(
    pageType ?? getPageTypeForSlug(slug)
  );

  const filterList = [...baseNumericFilters, ...extraNumericFilters(nowMs)];

  const minNum = parseInt(minWidth, 10);
  const maxNum = parseInt(maxWidth, 10);

  if (!Number.isNaN(minNum) && minNum >= 1) {
    filterList.push(`item_width>=${minNum}`);
  }

  if (!Number.isNaN(maxNum) && maxNum <= 300) {
    filterList.push(`item_width<=${maxNum}`);
  }

  return filterList;
};

export default buildCategoryAlgoliaNumericFilters;
